import { Kind } from "graphql";
function operationName(document) {
  var _a, _b;
  return ((_b = (_a = document.definitions.find(
    (node) => node.kind === Kind.OPERATION_DEFINITION && !!node.name
  )) == null ? void 0 : _a.name) == null ? void 0 : _b.value) ?? null;
}
function fragmentName(document) {
  var _a, _b;
  return ((_b = (_a = document.definitions.find((node) => node.kind === Kind.FRAGMENT_DEFINITION)) == null ? void 0 : _a.name) == null ? void 0 : _b.value) ?? null;
}
export {
  fragmentName,
  operationName
};
//# sourceMappingURL=name.mjs.map
